import { HourWiseReworkModel } from "./hour-wise-rework.model";

export class LineWorkStationReworkModel {
    lineId: string;
    lineDesc: string;
    totalRework: number;
    hourWiseReworkData: HourWiseReworkModel[];

    constructor(lineId: string,
        lineDesc: string,
        totalRework: number,
        hourWiseReworkData: HourWiseReworkModel[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.totalRework = totalRework;
            this.hourWiseReworkData = hourWiseReworkData;
    }
}